import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import heroTeam from "@/assets/hero-team.webp";

export function Hero() {
  useEffect(() => {
    // Inject a preload hint for the LCP image so it's discoverable as early as possible.
    if (typeof document === "undefined") return;
    const existing = document.head.querySelector(
      `link[rel="preload"][as="image"][href="${heroTeam}"]`
    );
    if (existing) return;
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = heroTeam;
    link.fetchPriority = "high";
    link.type = "image/webp";
    document.head.appendChild(link);
  }, []);

  return (
    <section className="relative min-h-[600px] lg:min-h-[700px] flex items-center">
      {/* Background Image (real img for LCP preload + fetchpriority) */}
      <img
        src={heroTeam}
        alt=""
        aria-hidden="true"
        fetchPriority="high"
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover"
      />
      {/* Left dark overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-foreground/75 via-foreground/45 to-foreground/10" />

      {/* Content */}
      <div className="relative container-main py-16 lg:py-24">
        <div className="inline-block bg-foreground/30 backdrop-blur-sm rounded-2xl p-5 md:p-8">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[56px] font-bold text-background leading-[1.1] mb-6 uppercase animate-fade-up">
            <span className="bg-foreground/80 px-2 py-1 inline-block mb-2 whitespace-nowrap">Skilled People.</span>
            <br />
            <span className="inline-block">Dedicated to</span>
            <br />
            <span className="bg-primary px-2 py-1 inline-block mt-1">Your Business.</span>
          </h1>

          <ul className="text-base md:text-lg text-background/90 mb-8 max-w-xl space-y-2 animate-fade-up drop-shadow-[0_1px_3px_rgba(0,0,0,0.6)]" style={{ animationDelay: '100ms' }}>
            <li className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0" />World-class headquarters</li>
            <li className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0" />24/7 Operational capacity</li>
            <li className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0" />Elite South African talent</li>
            <li className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0" />On-site leadership</li>
            <li className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0" />Full AI integration</li>
          </ul>

          <div className="flex flex-wrap gap-4 animate-fade-up" style={{ animationDelay: '200ms' }}>
            <Link to="/book-a-meeting">
              <Button size="lg" className="uppercase text-xs font-semibold tracking-wide bg-gradient-to-r from-secondary to-primary text-primary-foreground hover:opacity-90 rounded-full shadow-lg">
                Book a Meeting
              </Button>
            </Link>
            <Link to="/our-services">
              <Button variant="heroOutline" size="lg" className="uppercase text-xs font-semibold tracking-wide">
                Explore Services
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
